import styled from "styled-components/native";
import { View } from "react-native";
import { useQaLabel } from "../../../hooks";

export const StyledViewContainer = styled(View).attrs<{
  qaLabel?: string;
}>((props: { qaLabel?: string }) => ({
  ...useQaLabel(props.qaLabel || "StyledViewContainer")
}))<{
  position: string;
  height: string;
  width: string;
  qaLabel?: string;
}>`
  position: absolute;
  z-index: 1;
  width: ${({ width }: { width: string }) => width || `44px`};
  height: ${({ height }: { height: string }) => height || `48px`};
  ${({ position }: { position: string }) =>
    position === "end" ? `right: 0` : position === "bottom" && `top: 99%`};
`;
